/* eslint-disable */
export const enum Table {
    left = "left",
    center = "center",
    right = "right",
}
